import { debounce } from 'lodash';
import tippy from 'tippy.js/headless';
import domReady from '../helpers/dom-ready';

class WCMyAccount {
  static init(...parameters) {
    return new WCMyAccount(...parameters);
  }

  constructor() {
    this.container = document.querySelector('.page-wrapper');
    this.tabMenuWrapper = document.querySelector('.woocommerce-MyAccount-navigation');
    if (this.container) {
      this.menuWrapper = this.container.querySelector('.menu-wrapper');

      // this.addButtonClickEvents('.menu-wrapper .menu-button');
    }

    if (this.tabMenuWrapper) {
      this.tabMenu = this.tabMenuWrapper.querySelector('ul');

      this.tabMenuScrollWidth = this.tabMenu.scrollWidth;

      this.toggleDropdown();
      window.addEventListener('resize', debounce(() => {
        this.toggleDropdown();
      }), 300);
    }
  }

  // addButtonClickEvents(buttonSelector) {
  //   const menuButtons = this.container.querySelectorAll(buttonSelector);

  //   [...menuButtons].forEach((menuButton) => {
  //     menuButton.addEventListener('click', () => {
  //       this.setCurrent(menuButtons, menuButton);
  //     });
  //   });
  // }

  // setCurrent(menuButtons, target) {
  //   const loginSection = this.container.querySelector('.login-section');
  //   const loginHeading = this.container.querySelector('.login-heading');
  //   const registerSection = this.container.querySelector('.register-section');
  //   const registerHeading = this.container.querySelector('.register-heading');
  //   [...menuButtons].forEach((menuButton) => {
  //     if (menuButton === target) {
  //       menuButton.classList.add('-current');
  //     } else {
  //       menuButton.classList.remove('-current');
  //     }

  //     if (target.classList.contains('login-button')) {
  //       loginSection.classList.remove('-hidden');
  //       loginHeading.classList.remove('-hidden');
  //       registerSection.classList.add('-hidden');
  //       registerHeading.classList.add('-hidden');
  //     }

  //     if (target.classList.contains('register-button')) {
  //       registerSection.classList.remove('-hidden');
  //       registerHeading.classList.remove('-hidden');
  //       loginSection.classList.add('-hidden');
  //       loginHeading.classList.add('-hidden');
  //     }
  //   });
  // }

  toggleDropdown() {
    const { offsetWidth } = this.tabMenuWrapper;

    if (offsetWidth <= this.tabMenuScrollWidth) {
      this.tabMenuWrapper.classList.add('-hidden');
      this.tabMenuWrapper.setAttribute('aria-hidden', 'true');

      if (!this.dropdownMenuWrapper) {
        this.addDropdownMenu();
      } else {
        this.dropdownMenuWrapper.classList.remove('-hidden');
      }
    } else {
      if (this.dropdownMenuWrapper) {
        this.dropdownMenuWrapper.classList.add('-hidden');
      }

      this.tabMenuWrapper.classList.remove('-hidden');
      this.tabMenuWrapper.setAttribute('aria-hidden', 'false');
    }
  }

  addDropdownMenu() {
    this.dropdownMenuWrapper = document.createElement('div');
    this.dropdownMenuWrapper.classList.add('dropdown-menu-wrapper');
    this.dropdownMenuToggle = document.createElement('button');
    this.dropdownMenuToggle.classList.add('dropdown-menu-toggle');
    this.dropdownMenu = this.tabMenu.cloneNode(true);
    this.dropdownMenu.classList.remove('tab-menu');
    this.dropdownMenu.classList.add('dropdown');

    this.currentPageLink = this.dropdownMenu.querySelector('.is-active');
    if (this.currentPageLink) {
      this.currentPageLinkLabel = this.currentPageLink.querySelector('a');
      this.dropdownMenuToggle.innerHTML = this.currentPageLinkLabel.innerHTML;
      this.dropdownMenu.removeChild(this.currentPageLink);
    }

    this.dropdownMenuWrapper.appendChild(this.dropdownMenuToggle);
    this.dropdownMenuWrapper.appendChild(this.dropdownMenu);
    this.tabMenuWrapper.after(this.dropdownMenuWrapper);

    if (!this.tippyInstance) {
      this.setUpTippy();
    }
  }

  setUpTippy() {
    this.tippyInstance = tippy(this.dropdownMenuToggle, {
      content: this.dropdownMenu,
      offset: [0, 0],
      allowHTML: true,
      trigger: 'click',
      appendTo: this.dropdownMenuWrapper,
      interactive: 'true',
      placement: 'bottom-start',
      plugins: [{
        name: 'hideOnPopperBlur',
        defaultValue: true,
        fn(instance) {
          return {
            onCreate() {
              instance.popper.addEventListener('focusout', (event) => {
                if (
                  instance.props.hideOnPopperBlur
                      && event.relatedTarget
                      && !instance.popper.contains(event.relatedTarget)
                ) {
                  instance.hide();
                }
              });
            },
          };
        },
      }],
      popperOptions: {
        strategy: 'fixed',
        modifiers: [
          {
            name: 'preventOverflow',
            options: {
              padding: 0,
            },
          },
        ],
      },
      render(instance) {
        const popper = document.createElement('div');
        popper.appendChild(instance.props.content);
        return { popper };
      },
    });
  }
}

domReady(() => {
  WCMyAccount.init();
});
